import React from 'react';
import { Table, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import Select from 'react-select';
import { postRequestOptions, getRequestOptions } from "../helpers/Fetchwrapper";
import { Card } from 'react-bootstrap-v5';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { numberFormat } from '../helpers/GlobalHelper';

interface StockAgingData {
    id_items: number;
    item_code: string;
    item_name: string;
    category: string;
    uom: string;
    opening_qty: number;
    opening_value: number;
    received_qty: number;
    received_value: number;
    consumption_qty: number;
    consumption_value: number;
    closing_qty: number;
    closing_value: number;
    last_receive_date: string;
    last_receive_ref_no: string;
}

interface StockAgingReportProps {

}

const StockAgingReport: React.FC<StockAgingReportProps> = (props) => {

    const [loading, setLoading] = useState(false);
    const [stockAgingData, setStockAgingData] = useState<StockAgingData[]>([]);
    const [formData, setFormData] = useState({
        idProjects: '',
        idWarehouses: '',
        fromDate: '',
        toDate: '',
    });

    const [projects, setProjects] = useState<any[]>([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [warehouses, setWarehouses] = useState<any[]>([]);
    const [warehouse, setWarehouse] = useState<{ label: string; value: string }>({ label: 'All Warehouses', value: '' });

    useEffect(() => {
        getProjects();
    }, [])

    useEffect(() => {
        if (projects.length > 0) {
            setProject(projects[0]);
            setFormData((prevFormData) => ({
                ...prevFormData,
                idProjects: projects[0].value,
            }));
            getWarehousesByProject(projects[0].value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projects]);
    
    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getWarehousesByProject = (idProjects: number | string) => {
        if (!idProjects) {
            setWarehouses([]);
            setWarehouse({ label: 'All Warehouses', value: '' });
            return;
        }
        fetch(
            process.env.REACT_APP_API_URL + 'warehouse/' + idProjects + '/list',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success && Array.isArray(resp.data)) {
                    const whOptions = resp.data.map((item: any) => ({
                        label: item.name,
                        value: String(item.id_warehouses),
                    }));
                    setWarehouses(whOptions);
                } else {
                    setWarehouses([]);
                }
                setWarehouse({ label: 'All Warehouses', value: '' });
                setFormData((prev) => ({ ...prev, idWarehouses: '' }));
            })
            .catch(() => {
                setWarehouses([]);
                setWarehouse({ label: 'All Warehouses', value: '' });
                setFormData((prev) => ({ ...prev, idWarehouses: '' }));
            });
    };

    const handleProjectChange = (project: any) => {
        setProject(project);
        if (project) {
            setFormData({ ...formData, idProjects: project.value, idWarehouses: '' });
            getWarehousesByProject(project.value);
        } else {
            setFormData({ ...formData, idProjects: '', idWarehouses: '' });
            setWarehouses([]);
            setWarehouse({ label: 'All Warehouses', value: '' });
        }
    }

    const handleWarehouseChange = (selectedWarehouse: any) => {
        setWarehouse(selectedWarehouse || { label: 'All Warehouses', value: '' });
        setFormData({
            ...formData,
            idWarehouses: selectedWarehouse?.value || '',
        });
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleViewReport = async () => {
        if (!formData.idProjects || !formData.fromDate || !formData.toDate) {
            toast.error('Please fill all required fields', { position: 'bottom-right', autoClose: 4000 });
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(process.env.REACT_APP_API_URL + 'reports/stock-aging-report', postRequestOptions(formData));
            const data = await response.json();

            if (data.success) {
                setStockAgingData(data.data || []);
            } else {
                setStockAgingData([]);
                if (data.errors && Array.isArray(data.errors)) {
                    data.errors.forEach((error: string) => toast.error(error, { position: 'bottom-right', autoClose: 4000 }));
                } else {
                    toast.error('Failed to load report', { position: 'bottom-right', autoClose: 4000 });
                }
            }
        } catch (error) {
            console.error('Error submitting data:', error);
            toast.error('Error loading report', { position: 'bottom-right', autoClose: 4000 });
        } finally {
            setLoading(false);
        }
    };

    const queryParams = new URLSearchParams(formData);

    const stickyHeaderStyle: React.CSSProperties = {
        position: 'sticky',
        top: 0,
        zIndex: 1021,
        backgroundColor: '#f8f9fa',
        boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)',
        whiteSpace: 'nowrap'
    };

    return (
        <>
            <Card className='mb-4'>
                <Card.Body>
                    <Card.Title></Card.Title>
                    <Card.Text>
                        <div className='row align-items-end'>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="project">
                                    <Form.Label>Project<span className='required'></span></Form.Label>
                                    <Select
                                        value={project}
                                        onChange={handleProjectChange}
                                        options={projects}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        isClearable={true}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="warehouse">
                                    <Form.Label>Warehouse</Form.Label>
                                    <Select
                                        value={warehouse.value ? warehouse : { label: 'All Warehouses', value: '' }}
                                        onChange={handleWarehouseChange}
                                        options={[{ label: 'All Warehouses', value: '' }, ...warehouses]}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        isClearable={true}
                                        isDisabled={!project?.value}
                                        placeholder="All Warehouses"
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="fromDate">
                                    <Form.Label>From Date<span className='required'></span></Form.Label>
                                    <Form.Control type="date" placeholder="From Date" name='fromDate' value={formData.fromDate} onChange={handleChange} />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="toDate">
                                    <Form.Label>To Date<span className='required'></span></Form.Label>
                                    <Form.Control type="date" placeholder="To Date" name='toDate' value={formData.toDate} onChange={handleChange} />
                                </Form.Group>
                            </div>
                            <div className='col-md-4 mb-3'>
                                <div className="d-flex gap-2">
                                    <button className='btn btn-sm btn-primary flex-fill py-3' onClick={handleViewReport} disabled={loading}>
                                        {loading && (
                                            <span className="spinner-border spinner-border-sm me-1"></span>
                                        )}
                                        <span>View Report</span>
                                    </button>
                                    <a className="btn btn-sm btn-primary flex-fill py-3 text-nowrap" href={`${process.env.REACT_APP_BACKEND}stock_aging_report_download?` + queryParams.toString()}>
                                        <i className='fas fa-download me-1'></i>Excel Download
                                    </a>
                                </div>
                            </div>
                        </div>

                    </Card.Text>
                </Card.Body>
            </Card>

            <div className='row'>
                <div className='col-12'>
                    <div style={{ 
                        maxHeight: 'calc(100vh - 300px)', 
                        overflowY: 'auto', 
                        overflowX: 'auto',
                        position: 'relative'
                    }}>
                        <Table bordered hover style={{ marginBottom: 0, width: '100%' }}>
                            <thead>
                                <tr>
                                    <th className='text-center' style={stickyHeaderStyle}>Item Code</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Item Name</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Category</th>
                                    <th className='text-center' style={stickyHeaderStyle}>UOM</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Opening Qty</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Opening Value</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Received Qty</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Received Value</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Consumption Qty</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Consumption Value</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Closing Qty</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Closing Value</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Last Receive Date</th>
                                    <th className='text-center' style={stickyHeaderStyle}>Receive No(GRN)</th>
                                </tr>
                            </thead>
                            
                            <tbody>
                               {stockAgingData.length === 0 ? (
                                    <tr>
                                        <td colSpan={14} className='text-center'>No data available</td>
                                    </tr>
                                ) : (
                                    stockAgingData.map((item: StockAgingData, index: number) => (
                                        <tr key={index}>
                                            <td>{item.item_code || ''}</td>
                                            <td>{item.item_name || ''}</td>
                                            <td>{item.category || ''}</td>
                                            <td>{item.uom || ''}</td>
                                            <td className='text-end'>{numberFormat(item.opening_qty || 0)}</td>
                                            <td className='text-end'>{numberFormat(item.opening_value || 0)}</td>
                                            <td className='text-end'>{numberFormat(item.received_qty || 0)}</td>
                                            <td className='text-end'>{numberFormat(item.received_value || 0)}</td>
                                            <td className='text-end'>{numberFormat(item.consumption_qty || 0)}</td>
                                            <td className='text-end'>{numberFormat(item.consumption_value || 0)}</td>
                                            <td className='text-end'>{numberFormat(item.closing_qty || 0)}</td>
                                            <td className='text-end'>{numberFormat(item.closing_value || 0)}</td>
                                            <td>{item.last_receive_date || ''}</td>
                                            <td>{item.last_receive_ref_no || ''}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>

                        </Table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StockAgingReport;